import React, { useEffect, useRef, useState } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchAdminSaleData } from '../../Store/PHPSlice/stockApi';
import { selectAdminSaleData, selectStkInwdata, selectUstkInwdata } from '../Selectors/Master/OutwardSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import { fetchStkInwData, fetchUserStkInwData } from '../../Store/PHPSlice/StkInw';


const UserStkBillView = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState({
        ID: '',
        balamt: '',
        billNo: '',
        cgst: '',
        discnt_amt: '',
        discnt_type: '',
        discnt_val: '',
        dt: '',
        freight_ch: '',
        gst: '',
        gst_val: '',
        igst: '',
        netamt: '',
        other_ch: '',
        schlId: '',
        schlNm: '',
        schlcd: '',
        sgst: '',
        totamt: '',
        totissqty: '',
        zoneId: '',
        zoneNm: '',
        firmId: '',
        firmNm: '',
        adrs: '',
        schladrs: "",
        firmph: '',
        fgst: '',
        schlph: '',
        totrate: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        fadrs: '',
        fph: '',
        bnkNm: '',
        brnchNm: '',
        ifsc: '',
        accno: '',
        p_ph: '',
        p_adrs: '',
        partyNm: ''
    });
    const [packInfo, setPackInfo] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});

    const packData = useSelector(selectUstkInwdata);
    const firmlist = useSelector(selectFirm);
    console.log(packData)

    useEffect(() => {
        dispatch(fetchUserStkInwData({ id: Id }));
        dispatch(fetchCompanyData());
    }, [Id, dispatch]);

    useEffect(() => {
        if (packData?.data) {
            const item = packData?.data;
            const {
                ID,
                balamt,
                stkMemo,
                cgst,
                discnt_amt,
                discnt_type,
                discnt_val,
                dt,
                DT,
                freight_ch,
                gst,
                gst_val,
                igst,
                netamt,
                other_ch,
                schlId,
                schlNm,
                sgst,
                totamt,
                totqty,
                zoneId,
                zoneNm,
                firmId,
                firmNm,
                fadrs,
                schladrs,
                fGST,
                fph,
                schlph,
                schlcd,
                bankNm,
                branchNm,
                ifsc,
                ac_no,
                p_ph,
                p_adrs,
                partyNm,
                totdisamt,
                schlMemo,
                billNo

            } = item;
            const firmdata = firmlist?.data?.find(item => item.ID === firmId);
            setSelectFirmdata(firmdata);
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
            const totamt2 = info?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);
            let sgstper, igstper, cgstper;
            if (igst === '0') {
                sgstper = (parseFloat(gst_val) / 2);
                cgstper = (parseFloat(gst_val) / 2);
                igstper = 0;
            } else {
                igstper = gst;
                sgstper = 0;
                cgstper = 0;
            }
            setFormData(prev => ({
                ...prev,
                ID: ID,
                balamt: balamt,
                billNo: billNo,
                cgst: cgst,
                discnt_amt: discnt_amt,
                discnt_type: discnt_type,
                discnt_val: discnt_val,
                dt: DT,
                freight_ch: freight_ch,
                fgst: fGST,
                gst: gst,
                gst_val: gst_val,
                igst: igst,
                netamt: totdisamt,
                other_ch: other_ch,
                schlId: schlId,
                schlNm: schlNm,
                sgst: sgst,
                totamt: totamt2,
                totissqty: totqty,
                zoneId: zoneId,
                zoneNm: zoneNm,
                firmId: firmId,
                firmNm: firmNm,
                fadrs: fadrs,
                schladrs: schladrs,
                schlph: schlph,
                fph: fph,
                totrate: totrate,
                igstper: igstper,
                sgstper: sgstper,
                cgstper: cgstper,
                schlcd: schlcd,
                bnkNm: bankNm,
                brnchNm: branchNm,
                ifsc: ifsc,
                accno: ac_no,
                p_adrs: p_adrs,
                p_ph: p_ph,
                partyNm: partyNm
            }));
        }
        if (packData?.info && packData?.info?.length > 0) {
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
            setPackInfo(info);
        }
    }, [packData]);

    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }

    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"
    // console.log(packInfo);


    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    <h3 className="heading">Stock Inward View</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData.firmNm}</h2>
                                        <b>Add.:</b>{formData.fadrs}
                                        <br />
                                        <b>Contact:</b>{formData.fph} <br />
                                        <b>GST No.:</b> {formData.fgst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3>
                                        <b>School Name:</b><b style={{ color: 'blue' }}> -</b> <br />
                                        <b>Code:</b><b style={{ color: 'blue' }}>{formData.schlcd} </b> <br />

                                        <b>Add:</b> <span style={{ color: 'blue' }}>-</span>
                                        <br />

                                        <b>Contact:</b> <span style={{ color: 'blue' }}></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Bill No:</td>
                                    <td><b>{formData.billNo}</b></td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                {/* <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr> */}
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.disrate}</td>
                                        <td>{item.disamt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totissqty}</b></td>
                                    <td><b></b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS:
                                        <b>{numberToWords(parseFloat(formData.netamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {formData.totissqty}</b></td>
                                </tr>


                                <tr>
                                    <td>Bank Name: <b> {formData.bnkNm}</b></td>



                                </tr>
                                <tr>
                                    <td>Account No.: <b> {formData.accno}</b></td>
                                </tr>

                                <tr>
                                    <td>IFSC code: <b> {formData.ifsc}</b></td>
                                </tr>

                                <tr>
                                    <td>Branch Name: <b> {formData.brnchNm}</b></td>
                                </tr>

                            </tbody>
                        </table>

                        <table>

                            <tbody>

                                <tr>
                                    <td><b>SUB TOTAL :</b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                                <tr>
                                    <td><b>DISCOUNT AMOUNT ({formData.discnt_val}{formData.discnt_type}) :</b></td>
                                    <td><b>{formData.discnt_amt}</b></td>
                                </tr>
                                <tr>

                                    <td><b>CGST({formData.cgstper}%)</b></td>
                                    <td>
                                        <b>{formData.cgst}</b>
                                    </td>
                                </tr>
                                <tr>

                                    <td><b>SGST({formData.sgstper}%)</b></td>
                                    <td>
                                        <b>{formData.sgst}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>IGST({formData.igstper}%)</b></td>
                                    <td>
                                        <b>{formData.igst}</b>
                                    </td>
                                </tr>


                                <tr>

                                    <td><b style={{ color: 'red' }}>FREIGHT</b></td>
                                    <td>
                                        <b style={{ color: 'red' }}>{formData.freight_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>OTHERS</b></td>
                                    <td>
                                        <b>{formData.other_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b style={{ color: 'blue' }}>GRAND TOTAL</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{formData.netamt}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div>
            </Paper>
        </Grid>
    );
};

export default UserStkBillView;